import { render, staticRenderFns } from "./OnsaleHomeHeader.vue?vue&type=template&id=6a882529&scoped=true&"
import script from "./OnsaleHomeHeader.vue?vue&type=script&lang=js&"
export * from "./OnsaleHomeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a882529",
  null
  
)

export default component.exports